import swiper from 'swiper';

var serviseNav = new swiper ('.js-top-service-slider-nav', {
  // Optional parameters
  direction: 'vertical',
  loop: false,
  // slidesPerView: 4,
  speed:500,
  autoplay: false,
  spaceBetween: 15,
  // centeredSlides: true,
  observer: true,
  // observeParents: true,
  preloadImages: false,
  // noSwiping: true,
  slidesPerView: "auto",
  autoHeight: true,
  allowTouchMove: false,
  // watchSlidesVisibility: true,
  // watchSlidesProgress: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2
  },
  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  breakpoints: {
    768: {
      direction: 'horizontal',
      allowTouchMove: true,
      slidesPerView: 4
    }
  }
});

var serviseMain = new swiper ('.js-top-service-slider-main', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  effect: "fade",
  // slidesPerView: 5,
  speed:500,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  spaceBetween: 0,
  centeredSlides: true,
  observer: true,
  // observeParents: true,
  preloadImages: false,
  // noSwiping: true,
  slidesPerView: "auto",
  autoHeight: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2
  },
  navigation: {
    nextEl: '.top-service-slider__nav-button.is-next',
    prevEl: '.top-service-slider__nav-button.is-prev',
  },
  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  breakpoints: {
    768: {
      direction: 'horizontal',
      allowTouchMove: true,
    }
  },
  thumbs: {
    // swiper: serviseNav
  },
  on: {
    init: function () {
      $(".js-top-service-slider-nav .swiper-slide").eq(this.realIndex).addClass("is-active");
    }
  }
});

$('.js-top-service-slider-nav .swiper-slide').each(function(i, v) {
  $(this).on("click", function() {
    serviseMain.slideTo(i + 1);
  })
})

serviseMain.on('slideChange', function(){
  var index = serviseMain.realIndex;
  // console.log("メイン画像" + index);
  $(".js-top-service-slider-nav .swiper-slide").removeClass("is-active");
  $(".js-top-service-slider-nav .swiper-slide").eq(index).addClass("is-active");
});
